// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__D-Bh1","redirect_btn":"NotFoundPage_redirect_btn__0Tc03"};